<template>
	<div>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
			<h1 class="h3 mb-0 text-gray-800">Feriados</h1>
			<div>
				<button class="btn btn-sm btn-success" @click="add">Novo</button>
			</div>
	    </div>

	    <alert :type="alert.type" :mensagem="alert.msg" />
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<div class="row">
			<table class="table table-striped table-hover table-sm table-responsive-xl">
				<thead align="center">
					<th @click="orderBy('id')"         >ID           <font-awesome-icon v-if="direction.by == 'id'"         :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('nome')"   >NOME     <font-awesome-icon v-if="direction.by == 'nome'"   :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('data')"  >DATA    <font-awesome-icon v-if="direction.by == 'data'"  :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('created_at')" >ADICIONADO EM<font-awesome-icon v-if="direction.by == 'created_at'" :icon="order_icon" size="xs" /></th>
					<th @click="orderBy('updated_at')" >ALTERADO EM  <font-awesome-icon v-if="direction.by == 'updated_at'" :icon="order_icon" size="xs" /></th>
					<th></th>
				</thead>
				
				<transition mode="out-in" name="leftIn">
					<tbody v-if="feriados" align="center">
						<tr v-for="(feriado, index) in feriados.result.data" :key="index">
							<td>{{ feriado.id }}</td>
							<td>{{ feriado.nome }}</td>
							<td>{{ feriado.dia +"/"+feriado.mes }}</td>
							<td>{{ feriado.created_at | moment("DD/MM/YYYY") }}</td>
							<td>{{ feriado.updated_at | moment("DD/MM/YYYY") }}</td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(feriado)" /></td>
						</tr>
					</tbody>
					<Loading v-else />
				</transition>
			</table>
		</div>

	    <controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
        <modal :feriado="modal_data" @alert="show_alert" />
	</div>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import alert    from "@/components/Tools/alert.vue"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"
	import modal    from "@/components/Modal/Views/Feriados.vue"

	export default {
		name: "Feriados",
		mixins: [api, replace],
		components: { controls, filtros, alert, modal },

		data() { 
			return {
				feriados: {},
				constrol_data: {},
				modal_data: { 
					id: "", 
					nome: "", 
					dia: "", 
					mes:"" 
				},

				alert: { 
					type: "", 
					msg: "" 
				},

				direction: { 
					order: "desc", 
					by: "id" 
				},

				pagination: "10?",
				string_filter: "",

				filter_data: [
					{ 
						name: "id",         
						label: "ID",       
						type: "text",  
						data_get: ""
					},
					{ 
						name: "mes", 
						label: "Mes",     
						type: "select",  
						data_get: "Meses"
					},
					{ 
						name: "nome" ,  
						label: "Nome", 
						type: "text", 
						data_get: ""
					}
				],
				data_head: ["ID", "NOME", "MES"],
				data_body: ["id", "nome", "mes"]
			}
		},

		created() {
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{
					this.direction.by = payload;
				}

				this.get_data();
			},

			filtrar(payload) {
				this.string_filter = payload;
				this.get_data();
			},

			async get_data() {
				this.feriados = null;
				this.feriados = await this.GET("Feriados", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`);

				this.constrol_data = {
					current_page: this.feriados.result.current_page,
					last_page:    this.feriados.result.last_page,
					per_page:     this.feriados.result.per_page,
					total:        this.feriados.result.total,
				}
            },
            
            toggle_block(payload, index) {
                switch (index) {
                    case 'denuncia':
                        payload.denuncia = (payload.denuncia == 0) ? 1 : 0
                        break

                    case 'call_in':
                        payload.call_in = (payload.call_in == 0) ? 1 : 0
                        break

                    case 'call_out':
                        payload.call_out = (payload.call_out == 0) ? 1 : 0
                        break
                }

                this.PUT("Feriados", payload);
            },

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			add() {
                this.modal_data = {
                    id: '',
                    nome: '',
                    dia: '',
                    mes: ''
                }
                
				$("#modal-feriados").modal();
			},

			view(payload) {
                this.modal_data = payload;
                this.modal_data.dia = this.modal_data.dia+"/"+this.modal_data.mes;
				$("#modal-feriados").modal();
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
				this.alert.msg  = payload.result;

				$("#modal-feriados").modal('hide');
				this.get_data();
				$("#app-alert").show();
				setTimeout(() => $("#app-alert").hide(), 3000 );
			},

			icon_if_block(payload) {
				return ( payload == 1 ) ? "Bloqueado" : "";
			},
		},
	}
</script>

<style>
	
</style>